
import {
  defineComponent,
} from 'vue';

export default defineComponent({
  setup(props, context) {
    window.currentListSection.count += 1;

    const itemNumber = window.currentListSection.count;
    const { type } = window.currentListSection;

    const iconClasses = [
      type,
      itemNumber === 1 ? 'first' : null,
    ];

    const showHeadline = context.slots.headline && context.slots.headline().length;

    return {
      itemNumber,
      type,
      iconClasses,
      showHeadline,
    };
  },
});
